import CardTask from "./Card/CardTask";
import TaskBarChart from "./Chart/TaskBarChart";
import { useEffect, useState } from "react";
import {
  useGetUserBarChartPracticeQuery,
  useGetUserStatsPracticeQuery,
  useGetUserStatsQuery,
} from "../../../api/user/userDashboardApi";
import TaskPieChart from "./Chart/TaskPieChart";

const ActivityViewUser = ({ filter, tab }) => {
  const [card, setCard] = useState(Array(4).fill({}));
  const [barActivity, setBarActivity] = useState(null);
  const [pieActivity, setPieActivity] = useState();

  const { data: dataCard, isLoading: isLoadingCard } = useGetUserStatsQuery();

  const { data: dataPieActivity } = useGetUserStatsPracticeQuery(filter, {
    skip: !tab,
  });

  const { data: dataBarActivity } = useGetUserBarChartPracticeQuery(filter, {
    skip: !tab,
  });

  useEffect(() => {
    if (dataCard && dataCard.Data) {
      setCard(dataCard.Data);
    }
  }, [dataCard]);

  useEffect(() => {
    if (dataBarActivity && dataBarActivity.Data) {
      setBarActivity(dataBarActivity.Data);
    }
  }, [dataBarActivity]);

  useEffect(() => {
    if (dataPieActivity && dataPieActivity.Data) {
      setPieActivity(dataPieActivity.Data);
    }
  }, [dataPieActivity]);

  return (
    <div>
      <CardTask card={card} loading={isLoadingCard} />
      <div>
        <div className="grid grid-cols-12 gap-2 m-4 py-8 p-3 shadow-md rounded-lg">
          <div className="col-span-9">
            <TaskBarChart dataBar={barActivity} labelChart={"Stato Attività"} />
          </div>
          <div className="col-span-3">
            <TaskPieChart dataPie={pieActivity} labelChart={"User"} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActivityViewUser;
